import { Injectable } from '@angular/core';
import { getOptionalContext } from '@mkp/core/feature-interceptor';
import { catchError, map, of } from 'rxjs';
import { BaseHttpResource } from '../base-http.resource';
import { CoreListEnvelop, CreditRedemptionDto } from '@mkp/shared/models';

@Injectable({ providedIn: 'root' })
export class CreditRedemptionResource extends BaseHttpResource<
  CreditRedemptionDto,
  CoreListEnvelop<CreditRedemptionDto>
> {
  constructor() {
    super('credit-redemption');
  }

  canCreateCreditRedemption(accountId: string) {
    return this.getWithQuery({
      params: { limit: 0 },
      headers: { maxRetry: 1 },
      context: getOptionalContext(),
      withAccountId: accountId,
    }).pipe(
      map(({ _links }) => !!_links?.create),
      catchError(() => of(false))
    );
  }
}
